import { ICreateNewThreadProps } from 'modules/header/components/NewThreadButton';
import { IModalOptions } from 'modules/modals/types';

export const handleOpenCreateThreadModal = (open: (options: IModalOptions) => void) => {
  open({
    variant: 'fullRight',
    contentLabel: 'Create new thread',
    name: 'New Thread',
    modal: 'createThread',
    id: 'modal-create-thread',
  });
};

export const handleOpenNewRelatedThreadModal = ({
  open,
  name,
  tags,
  threadId,
}: ICreateNewThreadProps) => {
  open({
    variant: 'fullRight',
    contentLabel: 'Create new related thread',
    name: 'New Related Thread',
    modal: 'createThread',
    id: 'modal-create-related-thread',
    context: {
      name,
      tags,
      threadId,
    },
  });
};
